"use strict";

exports.__esModule = true;
exports.createHistogramQuery = void 0;
var createHistogramQuery = exports.createHistogramQuery = function createHistogramQuery(_ref) {
  var start = _ref.start,
    end = _ref.end,
    devices = _ref.devices,
    durationRangeList = _ref.durationRangeList,
    dataSource = _ref.dataSource,
    _ref$additionalFilter = _ref.additionalFilters,
    additionalFilters = _ref$additionalFilter === void 0 ? [] : _ref$additionalFilter;
  return {
    filters: {
      must: [{
        filterType: "range",
        fieldName: "timestamp",
        values: {
          gte: start,
          lt: end
        }
      }, {
        filterType: "term",
        fieldName: "type",
        values: dataSource,
        options: {}
      }, {
        filterType: "terms",
        fieldName: "entity.device",
        values: devices
      }].concat(additionalFilters),
      mustNot: []
    },
    bins: [{
      binName: "by_range",
      fieldName: "duration",
      aggType: "range",
      options: {
        ranges: durationRangeList
      }
    }],
    metrics: ["count", "duration_sum"]
  };
};